<ng-template #loading>
  <ul nz-menu style="border: none" class="loader">
    <li
      *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6, 7]"
      style="padding: 0px 25px 0px 15px"
    >
      <nz-skeleton
        [nzTitle]="true"
        [nzActive]="true"
        [nzParagraph]="false"
      ></nz-skeleton>
    </li>
  </ul>
</ng-template>

<ng-template #error>
  <div class="error-container">
    <div class="error-msg">
      <va-icon name="exclamation-triangle" class="info-icon"></va-icon>
      <span class="error-text">{{ errMsg }}</span>
    </div>
  </div>
</ng-template>

<ng-template #success>
  <div class="nav-grid-container">
    <div class="grid-container-scroll">
      <table
        mat-table
        [dataSource]="dataSource"
        class="mat-elevation-z8 demo-table"
      >
        <ng-container matColumnDef="name" sticky>
          <th mat-header-cell *matHeaderCellDef rowspan="2" class="info-cell">
            <span class="info-header"
              >All numbers are in
              {{ displayUnitMag }}
              unless stated otherwise.</span
            >
          </th>
          <td mat-cell *matCellDef="let row" class="line-info-name-cell">
            <ng-container *ngIf="row.lineInfo.indent">
              <span
                [ngStyle]="{
                  'padding-left': row.lineInfo.indent * 10 + 'px'
                }"
              ></span>
            </ng-container>
            <span
              [ngClass]="{ bold: row.lineInfo.header || row.lineInfo.totaling }"
              >{{ row.lineInfo.name }}</span
            >
          </td>
        </ng-container>
        <ng-container
          *ngFor="let column of columnList"
          [matColumnDef]="column.colId + ''"
        >
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="column.colSpan">
            <span>{{ column.name }}</span>
            <span *ngIf="column.displayUnitMagnitude !== ''"
              >&nbsp;({{ column.displayUnitMagnitude }})</span
            >
          </th>
        </ng-container>
        <ng-container
          *ngFor="let column of sourceColumnsList"
          [matColumnDef]="column.sourceColId + ''"
        >
          <th
            mat-header-cell
            *matHeaderCellDef
            [ngClass]="{ 'external-note': column.hasNote }"
          >
            <div class="source-header-cell">
              <!-- show analyst here -->

              <div
                class="source-name"
                *ngIf="!expandableSourceIds.includes(column.sourceId)"
                nz-popover
                [nzPopoverContent]="contentTemplate"
                nzPopoverTrigger="hover"
                nzPopoverPlacement="bottom"
                [nzPopoverOverlayClassName]="'analyst-popover'"
                [ngClass]="{ 'consensus-col': column.sourceId === 10001 }"
              >
                <span *ngIf="column.sourceId !== 11111">
                  {{ column.sourceName }}</span
                >
                <span *ngIf="column.sourceId === 11111">
                  <span>Consensus</span>
                  <va-icon
                    size="small"
                    name="plus"
                    class="fa-sm cp-plus-icon"
                  ></va-icon>
                </span>
                <!-- add excluded icon here -->
                <span *ngIf="column.excluded">
                  <img
                    class="pad-icon"
                    src="{{ assets }}/icon-excluded.png"
                    title="Excluded from consensus"
                  />
                </span>
              </div>

              <!-- expandable sources  -->
              <div
                class="source-name expandable-col"
                [ngClass]="{ expanded: column.expanded }"
                *ngIf="expandableSourceIds.includes(column.sourceId)"
              >
                <div
                  *ngIf="!column.expanded"
                  class="icon"
                  (click)="showSources(column)"
                >
                  <va-icon
                    size="small"
                    name="plus-circle"
                    class="fa-sm"
                  ></va-icon>
                </div>
                <div
                  *ngIf="column.expanded"
                  class="icon"
                  (click)="hideSources(column)"
                >
                  <va-icon
                    size="small"
                    name="minus-circle"
                    class="fa-sm"
                  ></va-icon>
                </div>
                <span *ngIf="column.sourceId !== 11111">
                  {{ column.sourceName }}</span
                >
                <span *ngIf="column.sourceId === 11111">
                  <span>Consensus</span>
                  <va-icon
                    size="small"
                    name="plus"
                    class="fa-sm cp-plus-icon"
                  ></va-icon>
                </span>
              </div>
            </div>
          </th>

          <ng-template #contentTemplate>
            <div>
              <a
                routerLink="/reporting/analyst/{{
                  sourceInfo[column.sourceId].analystId
                }}"
                routerLinkActive="active"
                class="name"
                >{{ sourceInfo[column.sourceId].analystName }}</a
              ><br />
              <a
                href="mailto:{{ sourceInfo[column.sourceId].analystEmail }}"
                class="email"
              >
                {{ sourceInfo[column.sourceId].analystEmail }}</a
              ><br />
              <span
                class="date header"
                *ngIf="sourceInfo[column.sourceId].modelDate"
              >
                Model Date:&nbsp;</span
              >
              <span class="date">{{
                sourceInfo[column.sourceId].modelDate
              }}</span>
              <div *ngIf="column.hasNote" class="note">
                <span class="header">Note:&nbsp;</span>
                <span>{{ column.noteText }}</span>
              </div>
            </div>
          </ng-template>
          <td mat-cell *matCellDef="let row" class="cell-td">
            <div *ngIf="row.lineInfo.header" class="cell-container"></div>
            <div
              *ngIf="
                !row.lineInfo.header &&
                row.navCols[column.colId] &&
                row.navCols[column.colId].data[column.sourceId]
              "
            >
              <div
                *ngIf="row.navCols[column.colId].data[column.sourceId].hasNote"
                nz-popover
                nzPopoverTrigger="hover"
                [nzPopoverContent]="
                  row.navCols[column.colId].data[column.sourceId].noteText
                "
                nzPopoverPlacement="bottom"
                [nzPopoverOverlayClassName]="'notes-popover'"
                class="external-note"
              >
                <ng-container
                  *ngTemplateOutlet="
                    dataCell;
                    context: {
                      $implicit: row.navCols[column.colId].data[column.sourceId]
                    }
                  "
                ></ng-container>
              </div>
              <div
                *ngIf="!row.navCols[column.colId].data[column.sourceId].hasNote"
              >
                <ng-container
                  *ngTemplateOutlet="
                    dataCell;
                    context: {
                      $implicit: row.navCols[column.colId].data[column.sourceId]
                    }
                  "
                ></ng-container>
              </div>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
          class="first-header-row"
        ></tr>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedSourceColumnsHeader; sticky: true"
          class="second-header-row"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedSourceColumns"></tr>
      </table>
    </div>
    <ng-template #dataCell let-cellInfo>
      <div
        class="cell-container"
        [ngClass]="{
          'high-value': dataSettings.showHighLow && cellInfo.high,
          'low-value': dataSettings.showHighLow && cellInfo.low,
          'selected-line-cell': selectedRid === cellInfo.rid
        }"
        (click)="onCellClick(cellInfo)"
      >
        <span
          *ngIf="!cellInfo.isLoading"
          [ngClass]="{
            'negative-value': cellInfo.isNegative
          }"
        >
          {{ cellInfo.val }}
        </span>
        <span *ngIf="cellInfo.isLoading">
          <nz-skeleton
            [nzTitle]="true"
            [nzActive]="true"
            [nzParagraph]="false"
          ></nz-skeleton>
        </span>
      </div>
    </ng-template>
  </div>
</ng-template>
<ng-container *ngIf="metaLoading; then loading"></ng-container>
<ng-container *ngIf="hasMetaError; then error"></ng-container>
<ng-container
  *ngIf="!metaLoading && !hasMetaError; then success"
></ng-container>
